'use strict';

var values = require('../helpers/values');

module.exports = function every(fn) {
  var items = values(this.items);

  return items.map(function (item, index) {
    return fn(item, index);
  }).indexOf(false) === -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/every.js
// module id = 572
// module chunks = 0